import { deserialize } from 'cerialize'
import {
	ContactDetails,
	CreatedByUser,
	Details,
	OrderComments,
	OrderProductProfile,
	OrderRefusalStatuses,
	OrderStatus,
	User,
	Vko,
	MerchantModel,
} from 'Pages/archiveBroker'
import { PartnerShortModel, ShortDataModel } from 'Models'

export class ArchiveBrokerOrder {
	@deserialize public id: number
	@deserialize public archive: boolean
	@deserialize public assigned_to_user: User | null
	@deserialize public assigned_to_user_id: null
	@deserialize public auto_resending_count: number
	@deserialize public contact_details?: ContactDetails[]
	@deserialize public created_at: string
	@deserialize public created_by_user: CreatedByUser
	@deserialize public created_by_user_id: string
	@deserialize public crm_status: ShortDataModel
	@deserialize public details: Details[]
	@deserialize public external_id: string
	@deserialize public is_comments_read: boolean
	@deserialize public is_deleted: boolean
	@deserialize public is_read: boolean
	@deserialize public merchant: MerchantModel
	@deserialize public merchant_id: number
	@deserialize public mq_update_date: string
	@deserialize public number: string
	@deserialize public order_comments: OrderComments[]
	@deserialize public order_crm_status_id: number
	@deserialize public order_payment_status_id: number
	@deserialize public order_status: OrderStatus
	@deserialize public order_status_id: number
	@deserialize public partner: PartnerShortModel
	@deserialize public partner_id: number
	@deserialize public payment_status: ShortDataModel
	@deserialize public product_profile: OrderProductProfile
	@deserialize public product_profile_id: number
	@deserialize public refusal_status: OrderRefusalStatuses | null
	@deserialize public source: string
	@deserialize public unblock_request?: {
		status: {
			code: string
		}
	} | null
	@deserialize public updated_at: string
	@deserialize public updated_by_user: ShortDataModel
	@deserialize public updated_by_user_id: string
	@deserialize public vko: Vko
	@deserialize public vko_division: string
	@deserialize public vko_functional: string
	@deserialize public vko_mails: string
	@deserialize public vko_name: string
	@deserialize public vko_phones: string
}
